import * as Scrivito from "scrivito";
import { registerTextExtract } from "../../utils/textExtractRegistry";

const IntroSectionWidget = Scrivito.provideWidgetClass("IntroSectionWidget", {
  attributes: {
    image: ["reference", { only: ["Image"] }],
    ytVideo: ["widgetlist", { only: "YouTubeWidget" }],
    desc: "html",
    linkButton: "link",
  },
});

registerTextExtract("IntroSectionWidget", [
  { attribute: "desc", type: "html" },
]);

export default IntroSectionWidget;
